// extracted by mini-css-extract-plugin
export default {"Box":"style_Box__rtBoN"};